import axios from "axios";

// Get countries
async function getCountriesApi() {
    return axios({
        method: 'GET',
        url: '/api/v1/countries'
    });
}

export {
    getCountriesApi,
}
